import React from 'react';
import EditarSilobolsa from '../../components/silobolsa/editarSilobolsa';
import { PageWrapper } from '../../components/common';

const EditarSilobolsaPage: React.FC = () => {
  return (
    <PageWrapper>
      <EditarSilobolsa />
    </PageWrapper>
  );
};

export default EditarSilobolsaPage;

